/* eslint-disable */
import $ from 'jquery';
let slick = require('slick-carousel');

export default function () {


    //jQueryBridget('slick', Slick, $);
    $(".slider").slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        // normal options...
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        speed: 300,
        // the magic
        responsive: [{
            breakpoint: 760,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 300,
            settings: "unslick" // destroys slick
        }]
    });


    $(".slider-profile").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        // normal options...
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3500,
        dots: false,
        speed: 200,
        responsive: [
            {
                breakpoint: 760,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
    });

}
